import styled from 'styled-components';


export const Main = styled.main`
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  >div {
    padding: 64px 0px;
    border-bottom: 5px solid var(--color-gray);
  }

  >div:last-child{
    border:none;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  max-width: 70%;
  
  
  >div {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 50%;
    padding: 16px;

    >h2:first-child {
      font-family: 'Expansiva', sans-serif;
      font-size: 24px;
      line-height: 40px;
      text-align: center;
      border-bottom: 5px solid var(--color-gray);
      padding-bottom: 35px;
    }

    >p, ul {
      padding: 0 16px;
      padding-top: 35px;
      font-size: 16px;
      line-height: 28px;
      text-align: justify;
      
    }

    img {
      padding: 32px;
    }
  }

  @media screen and (max-width: 960px) {
    flex-wrap: wrap;
  
    img {
      width: 320px;
    }
  }
`;

export const SubMenu = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 16px;

  >a {
      font-family: 'Expansiva', sans-serif;
      cursor: pointer;
      margin: 16px;
      color: var(--color-gray);
      text-decoration: none;
      font-size: 20px;
      line-height: 40px;
      text-align: center;
      padding-bottom: 35px;

      &:hover{
        text-decoration: underline;
        color: var(--color-yellow);
        transition: all 0.2s;
      }
    }

    .submenu-active{
      text-decoration: underline;
      color: var(--color-yellow);
    }
`;

export const Square = styled.div`
  border: 1px solid var(--color-gray);

  img {
    width: 150px;
  }
`